/**
 * Copies text to the clipboard
 * @param text The text to copy
 * @returns Promise that resolves when copy is successful
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // Check if the Clipboard API is available
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error('Failed to copy using Clipboard API:', error);
      return false;
    }
  } else {
    return false;
  }
}
